import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CameraService } from '../../services/camera.service';
import { Camera } from '../../models/camera.model';

@Component({
  selector: 'app-camera-edit',
  templateUrl: './camera-edit.component.html',
  styleUrls: ['./camera-edit.component.css']
})
export class CameraEditComponent implements OnInit, OnDestroy {

  camera: Camera;
  previewUrl: String = "";
  interval = null;

  public errors: any = {};

  constructor(
    private router: Router,
    protected route: ActivatedRoute,
    protected cameraService: CameraService,
  ) {

    route.params.subscribe(routeSnap => {
      this.cameraService.show(routeSnap['_id']).subscribe(camera => {
        this.camera = camera;
        this.previewUrl = `http://${camera.ip}/lastFrame.png`
        this.interval = setInterval(() => {
          this.previewUrl = `http://${camera.ip}/lastFrame.png?ts=${Date.now()}`
        }, 500)
      });
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  submit() {
    this.cameraService.update(this.camera).subscribe(result => {
      return this.router.navigate(['/cameras']);
    }, errors => {
      this.errors = errors;
      console.log(errors);
    });
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/camera-edit/camera-edit.component.ts